export default __webpack_public_path__ + "static/media/coresanscr45it-webfont.00a4c367.woff2";